var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "back-btn",
          on: {
            click: function ($event) {
              return _vm.goSchool()
            },
          },
        },
        [
          _c("i", { staticClass: "el-icon-s-home" }),
          _c("span", [_vm._v("学校主页")]),
        ]
      ),
      _vm.liveDetail.status == 1 && _vm.liveDetail.review_url
        ? _c("iframe", {
            staticStyle: {
              width: "100%",
              height: "100%",
              "min-height": "15rem",
            },
            attrs: { src: _vm.liveDetail.review_url, frameborder: "0" },
          })
        : _vm.liveDetail.status == 3
        ? _c(
            "a",
            {
              staticClass: "view_box",
              attrs: { href: _vm.liveDetail.live_url },
            },
            [
              _c("div", { staticClass: "play" }),
              _c("el-image", {
                staticClass: "video-cover",
                attrs: { src: _vm.liveDetail.live_cover || _vm.DefaultCover },
              }),
            ],
            1
          )
        : _vm.liveDetail.live_cover
        ? _c("el-image", {
            staticClass: "video-cover",
            attrs: { src: _vm.liveDetail.live_cover },
          })
        : _vm._e(),
      _c("div", { staticClass: "tabs" }, [
        _c(
          "div",
          {
            staticClass: "tab-item",
            attrs: { "data-actived": _vm.activedTab === 0 },
            on: {
              click: function ($event) {
                _vm.activedTab = 0
              },
            },
          },
          [
            _vm.activedTab === 0
              ? _c("el-image", {
                  staticClass: "tab-icon",
                  attrs: { src: _vm.InfoIcon, fit: "cover" },
                })
              : _vm._e(),
            _c("span", [_vm._v("直播介绍")]),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "tab-item",
            attrs: { "data-actived": _vm.activedTab === 1 },
            on: {
              click: function ($event) {
                _vm.activedTab = 1
              },
            },
          },
          [
            _vm.activedTab === 1
              ? _c("el-image", {
                  staticClass: "tab-icon",
                  attrs: { src: _vm.SchoolIcon, fit: "cover" },
                })
              : _vm._e(),
            _c("span", [_vm._v("院校详情")]),
          ],
          1
        ),
      ]),
      _vm.activedTab === 0
        ? _c("div", { staticClass: "broadcast-info" }, [
            _c("div", { staticClass: "live-title-box" }, [
              _c("div", { staticClass: "live-title-content" }, [
                _c("h1", [_vm._v(_vm._s(_vm.liveDetail.title))]),
                _c("div", { staticClass: "live-info" }, [
                  _c(
                    "div",
                    { staticClass: "live-time" },
                    [
                      _c("el-image", {
                        staticClass: "time-icon",
                        attrs: { src: _vm.TimeIcon, fit: "cover" },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.liveDetail.live_time))]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "viewer-count" }, [
                    _c("i", { staticClass: "el-icon-view" }),
                    _c("span", [_vm._v(_vm._s(_vm.liveDetail.view_count))]),
                  ]),
                ]),
              ]),
              _vm.liveDetail.status == 2 && !_vm.liveDetail.is_subscribe
                ? _c(
                    "div",
                    {
                      staticClass: "subscribe-area",
                      class: _vm.statusColor,
                      on: { click: _vm.weChatAuth },
                    },
                    [
                      _c("el-image", {
                        staticClass: "subscribe-icon",
                        attrs: { src: _vm.SubscribeIcon, fit: "cover" },
                      }),
                      _c("span", { staticClass: "subscribe-text" }, [
                        _vm._v("提醒我"),
                      ]),
                      _vm.authInfo.openid
                        ? _c(
                            "wx-open-subscribe",
                            {
                              ref: "subscribe-btn",
                              attrs: {
                                id: "subscribe-btn",
                                template:
                                  "xE1HS2vV9-Qi4vS_qG-vUaOJ3shFXIvv4Km_lpVfQsg",
                              },
                            },
                            [
                              _c(
                                "script",
                                {
                                  tag: "component",
                                  attrs: { type: "text/wxtag-template" },
                                },
                                [
                                  _c("button", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      background: "transparent",
                                      border: "none",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm.liveDetail.status == 2 && _vm.liveDetail.is_subscribe
                ? _c(
                    "div",
                    {
                      staticClass: "subscribe-area",
                      class: _vm.statusColor,
                      on: { click: _vm.unsubscribeLive },
                    },
                    [
                      _c("el-image", {
                        staticClass: "subscribe-icon",
                        attrs: { src: _vm.SubscribeIcon, fit: "cover" },
                      }),
                      _c("span", { staticClass: "subscribe-text" }, [
                        _vm._v("取消提醒"),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "subscribe-area", class: _vm.statusColor },
                    [
                      _c("el-image", {
                        staticClass: "subscribe-icon",
                        attrs: { src: _vm.statusIcon, fit: "cover" },
                      }),
                      _c("span", { staticClass: "subscribe-text" }, [
                        _vm._v(_vm._s(_vm.statusText)),
                      ]),
                    ],
                    1
                  ),
            ]),
            _c("div", { staticClass: "broadcast-introduce" }, [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.liveDetail.content) },
              }),
            ]),
          ])
        : _vm._e(),
      _vm.activedTab === 1
        ? _c(
            "div",
            { staticClass: "instituition-info" },
            [
              _c("InstitutionCard", { attrs: { "card-data": _vm.schoolInfo } }),
              _c("div", { staticClass: "title-box" }, [
                _c("h2", [_vm._v("直播列表")]),
                _c("span", [
                  _vm._v(
                    "共" + _vm._s(_vm.recommendLiveList.length) + "场直播"
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "list-box" },
                _vm._l(_vm.recommendLiveList, function (item) {
                  return _c("ListCard", {
                    key: item.id,
                    attrs: { "card-data": item },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }